import React from "react";

import _ from "lodash";

type StandardWidthType = {
    [x: string]: boolean;
};

function getDefaultStandardWidth(): StandardWidthType {
    return {};
}

export const StandardWidth = React.createContext<StandardWidthType>(getDefaultStandardWidth());

export const StandardWidthActionsContext = React.createContext({
    toggleManageStandardWidth: (_page: string, _manage: boolean) => {
        // empty function
    },
    clearManageStandardWidth: () => {
        // empty function
    },
});

export const useStandardWidthContext = () => React.useContext(StandardWidth);

export const useStandardWidthActionsContext = () => React.useContext(StandardWidthActionsContext);

type PropsType = {
    children: JSX.Element;
};

export const StandardWidthContextProvider = (props: PropsType) => {
    const [manageStandardWidth, setManageStandardWidth] = React.useState<StandardWidthType>(
        getDefaultStandardWidth()
    );

    const toggleManageStandardWidth = React.useCallback((page: string, manage: boolean) => {
        setManageStandardWidth((prevState) => {
            const newState = _.cloneDeep(prevState);
            newState[page] = manage;

            return newState;
        });
    }, []);

    const clearManageStandardWidth = React.useCallback(() => {
        setManageStandardWidth(getDefaultStandardWidth());
    }, []);

    const standatdWidthActionsContextValue = React.useMemo(
        () => ({ toggleManageStandardWidth, clearManageStandardWidth }),
        [toggleManageStandardWidth, clearManageStandardWidth]
    );

    return (
        <StandardWidth.Provider value={manageStandardWidth}>
            <StandardWidthActionsContext.Provider value={standatdWidthActionsContextValue}>
                {props.children}
            </StandardWidthActionsContext.Provider>
        </StandardWidth.Provider>
    );
};
